import { combineReducers } from '@reduxjs/toolkit'

import { selectionReducer } from './features/sync/model/selectionSlice'

/** Состояние модуля `sync`: только намерение человека (отмеченные строки и источники-цели). Расхождения и сводка — в кэше запросов. */
export const syncUiReducer = combineReducers({ selection: selectionReducer })
export type SyncUiState = ReturnType<typeof syncUiReducer>
